export enum BonusXpressStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}
